<template>
  <div class="sc">
    <section v-if="!isLoadingVariants">
      <div class="sc-card">
        <slot name="header"
              v-bind:step="step"
        >
          <div class="sc-header">
            <div v-if="step===3" class="sc-back" @click="goStep(1)"><i class="sc-arrow"></i> Назад </div>
            <h2 class="sc-h2" v-if="step===1">Оформление заказа</h2>
            <h2 class="sc-h2" v-if="step===2">Добавьте к заказу</h2>
            <h2 class="sc-h2" v-if="step===3">Оформление заказа</h2>
          </div>
        </slot>
        <slot name="variants" v-bind:variants="variants" v-bind:form="form" v-if="step===1" v-bind:step="step">
          <div class="sc-variants">
            <div class="sc-variants-item" v-for="(variant, i) in variants" :key="'variant'+i">
              <div class="sc-variants-item-title sc-radio">

                <input type="radio" :id="'var-rad'+i" name="variant" class="sc-radio" :value="variant.id"
                       v-model="form.variant">
                <label v-if="variants.length > 1" :for="'var-rad'+i" class="sc-radio-label">
                  {{variant.title}}
                </label>
                <span v-else>{{variant.title}}</span>
              </div>
              <div class="sc-variants-item-price">{{formatPrice(variant.price) === '0' ? 'бесплатно' : (formatPrice(variant.price) + ' ₽') }}</div>
            </div>
          </div>
        </slot>

        <slot name="options" v-bind:options="availableOptions" v-bind:form="form" v-if="step===2" v-bind:step="step">
          <div v-for="(option, i) in availableOptions" :key="'option' + i">
            <label v-if="false">
              <input
                type="checkbox"
                name="options"
                :value="option.id"
                v-model="form.options"
              />
              {{ option.title }} ({{ Math.sign(option.price) >= 0 ? "+" : "-" }}
              {{ formatPrice(Math.abs(option.price)) }} Р-)
            </label>
          </div>
        </slot>

        <slot
          name="credit"
          v-bind:options="options"
          v-bind:canCredit="showCredit"
          v-bind:form="form"
          v-bind:creditPaymentsWithOptions="creditPaymentsWithOptions"
        >
          <div v-if="showCredit && false">
            <label>
              <input
                type="checkbox"
                name="credit"
                :value="true"
                v-model="form.credit"
              />
              Рассрочка
              <span v-if="creditPrice"
              >{{ Math.sign(creditPrice) >= 0 ? "+" : "" }}
              {{ formatPrice(creditPrice) }} ₽</span
              >
            </label>
            <ul v-if="showCreditPayment">
              <li :key="item.num" v-for="item in creditPaymentsWithOptions">
                {{ item.num + " платеж " + Number(item.price) + " ₽" }}
              </li>
            </ul>
          </div>
        </slot>
        <slot name="step3">
          <div v-if="step===3">
            <div class="sc-email-label">{{form.email}}</div>
            <div class="sc-order-items">
              <div class="sc-order-item">
                <div class="sc-order-item-label">{{selectedVariant.title}}</div>
                <div class="sc-order-item-price">{{formatPrice(selectedVariant.price)}} ₽</div>
              </div>
              <div class="sc-order-item" v-for="(avanse, i) in avanses" :key="i">
                <div class="sc-order-item-label">{{avanse.variant.title}}</div>
                <div class="sc-order-item-price sc-avanse">-{{formatPrice(avanse.amount)}} ₽</div>
              </div>
            </div>

          </div>
        </slot>
        <slot name="buttons">
          <div class="sc-buttons">
            <div v-if="step===1" class="sc-inputs">
              <input
                name="email"
                required=""
                type="text"
                class="sc-text-input"
                v-model="form.email"
                @keydown.enter="nextStep"
                placeholder="Введите ваш Email"
              />
              <div class="errors" v-if="error">{{ error }}</div>

              <input
                name="name"
                required=""
                type="text"
                class="sc-text-input mt16"
                v-model="form.name"
                placeholder="Имя"
                @keydown.enter="nextStep"
                v-if="selectedVariant.name_field"
              />

              <input
                name="name"
                required=""
                type="text"
                class="sc-text-input mt16"
                v-model="form.phone"
                placeholder="Телефон"
                @keydown.enter="nextStep"
                v-if="selectedVariant.phone_field"
              />
            </div>
            <button @click="nextStep" @keydown.enter="nextStep" :disabled="isSubmit" v-if="step===1" class="mt20 sc-button" :class="isSubmit ? 'loading' : ''">Заказать</button>
            <div v-if="step===3">
              <div>
                <ul class="sc-tabs">
                  <li class="sc-tabs-item" :class="{'sc-tabs-item-active': activeTab==='card-payment'}"
                      @click="activateTab('card-payment')">Оплата картой
                  </li>
                  <li class="sc-tabs-item" :class="{'sc-tabs-item-active': activeTab==='rassr'}"
                      @click="activateTab('rassr')" v-if="showCredit">Рассрочка
                  </li>
                </ul>
              </div>
              <div class="sc-order">
                <div class="sc-order-sum">
                  <div v-if="isCreditEnabled && activeTab==='rassr'" class="sc-credit-types">
                    <div class="sc-radio sc-credit-types-item">
                      <input type="radio" id="rassr_tinkoff" class="sc-radio"  v-model="creditType" value="school" @click="selectSchoolCredit">
                      <label for="rassr_tinkoff" class="sc-radio-label sc-credit-label">
                        Рассрочка от школы
                      </label>
                    </div>
                    <div class="sc-radio sc-credit-types-item">
                      <input type="radio" id="credit_tinkoff" class="sc-radio" v-model="creditType" value="tinkoff_3" @click="selectTinkoffCredit">
                      <label for="credit_tinkoff" class="sc-radio-label sc-credit-label">
                        Рассрочка от банка Тинькофф (3 мес)
                      </label>
                    </div>
                    <div class="sc-radio sc-credit-types-item">
                      <input type="radio" id="credit_tinkoff6" class="sc-radio" v-model="creditType" value="tinkoff_6" @click="selectTinkoffCredit">
                      <label for="credit_tinkoff6" class="sc-radio-label sc-credit-label">
                        Рассрочка от банка Тинькофф (6 мес)
                      </label>
                    </div>
                    <div class="sc-radio sc-credit-types-item">
                      <input type="radio" id="credit_tinkoff12" class="sc-radio" v-model="creditType" value="tinkoff_12" @click="selectTinkoffCredit">
                      <label for="credit_tinkoff12" class="sc-radio-label sc-credit-label">
                        Рассрочка от банка Тинькофф (12 мес)
                      </label>
                    </div>
                  </div>
                  <div class="sc-flex">
                    <div>
                      <div class="sc-order-sum-label" v-if="activeTab==='rassr' && creditType!=='school'">
                        {{ (creditType==='tinkoff_12'?'12':(creditType==='tinkoff_6'?'6':'3')) + noun(creditType==='tinkoff_12'?12:(creditType==='tinkoff_6'?6:3), ' платеж', ' платежа', ' платежей')+' по:'}}
                      </div>
                      <div class="sc-order-sum-label" v-else>
                        {{activeTab==='rassr'?creditPaymentsWithOptions.length+noun(creditPaymentsWithOptions.length, ' платеж', ' платежа', ' платежей')+' по:':'К оплате:'}}
                      </div>
                      <form
                            v-on:submit.prevent
                            method="post" ref="credit_form" v-show="false">
                        <input v-model="form.email" type="hidden"/>
                        <input name="shopId" value="maximsoldatkin" type="hidden"/>
                        <input name="showcaseId" value="maximsoldatkin" type="hidden"/>
                        <input name="promoCode" :value="promoCode" type="hidden"/>
                        <input name="sum" value="" type="hidden">
                        <input name="customerEmail" value="" type="hidden"/>
                        <input name="orderNumber" value="" type="hidden"/>
                        <input name="itemName_0" value="" type="hidden"/>
                        <input name="itemQuantity_0" value="1" type="hidden"/>
                        <input name="itemPrice_0" value="0.00" type="hidden"/>
                      </form>
                      <div class="sc-order-sum-value">{{ (creditType==='school' || activeTab !=='rassr') ? formatPrice(price):formatPrice(tinkoffCreditPartPrice) }} <span>₽</span></div>
                      <button v-if="creditType!=='school'"  @keydown.enter="tinkoffCredit(createOrder, form, selectedVariant)"  @click="tinkoffCredit(createOrder, form, selectedVariant)" class="mt25 sc-button" :disabled="isSubmit">Оформить</button>

                      <button v-if="creditType==='school'" @click="tinkoffInit" @keydown.enter="tinkoffInit" class="mt25 sc-button" :disabled="isSubmit">Оплатить</button>

                    </div>

                    <div>
                      <div class="sc-credit-details" v-if="activeTab==='rassr'">
                      <div class="sc-credit-graph">
                        <div class="sc-grey-text">Даты платежей:</div>
                        <div class="sc-payment-dates">{{paymentDatesString}}</div>
                      </div>
                      </div>
                    </div>
                  </div>
              </div>

              </div>
            </div>
          </div>
        </slot>

      </div>

      <slot
        name="footer"
        v-bind:price="price"
        v-bind:selectedVariant="selectedVariant"
        v-bind:form="form"
        v-bind:error="error"
        v-bind:createOrder="createOrder"
        v-bind:tinkoffInit="tinkoffInit"
        v-bind:creditPaymentsWithOptions="creditPaymentsWithOptions"
      >
        <div class="sc-footer">

          <p class="mt0" v-if="activeTab==='rassr' && creditType==='school'">Рассрочка от школы: оплата автоматически спишется с вашей карты согласно графику, можно отменить в любой момент.
          </p>
          <p class="mt0" v-if="activeTab==='rassr' && creditType!=='school'">Рассрочка от банка Тинькофф: гражданам РФ от 18 до 70 лет; решение о выдаче – 1-2 минуты; первоначальный взнос – 0 ₽ ; переплата – 0%; сумма от 3000 до 100 000 ₽. Карта Тинькофф не обязательна.
          </p>
          <span v-if="creditType==='school'">Принимаем карты любых стран. Платежи защищены SSL и 3D secure.</span>
          <!--<span v-if="tinkoff_credit_enabled && creditType==='school'">
            <label v-if="false">
              <input
                type="checkbox"
                id="oferta"
                v-model="form.offert_accept"
                :value="true"
              />
              Принимаю&nbsp;
            </label>

            <a
              v-if="school.oferta_mode === 1"
              target="_blank"
              :href="school.oferta_link"
              class="oferta-link sc-grey-text"
            >Договор оферты</a>
            <a v-if="school.oferta_mode === 2" @click="openOfert" class="oferta-link sc-grey-text">Договор оферты
            </a>

            <oferta name="oferta" :scrollable="true" height="auto">
              <div v-html="school.oferta_text" class="oferta-content"></div>
              <div class="vue-dialog-buttons">
                <button type="button" class="vue-dialog-button" style="flex: 1 1 100%;" @click="ofertaAccept" >
                  Принять
                </button>
              </div>
            </oferta>
          </span>-->
          <div class="sc-footer-images">

            <img src="https://schoolcloud.ru/images/payment_page/tinkoff-bank-simple-logo-2.png"
                 srcset="https://schoolcloud.ru/images/payment_page/tinkoff-bank-simple-logo-2@2x.png 2x,
                                https://schoolcloud.ru/images/payment_page/tinkoff-bank-simple-logo-2@3x.png 3x">

          </div>
        </div>
      </slot>
    </section>
  </div>
</template>

<script>

  import VModal from 'vue-js-modal'
  import Vue from 'vue'
  import {noun} from 'plural-ru'

  Vue.use(VModal, {componentName: 'oferta'})
  import axios from 'axios'
  import debounce from '../common/debounce.js'

  export default {
    name: 'ScForm',
    props: {
      url: {
        type: String,
        default: 'https://schoolcloud.ru'
      },
      tariffs: {
        required: true
      },
      selectedVariantId: {
        type: Number,
        required: false
      },
      email: {
        type: String,
        required: false
      },
      creditEnabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        noun: noun,
        variantIds: 2,
        isLoadingVariants: true,
        form: {
          variant: this.selectedVariantId,
          options: [],
          credit: false,
          credit_stage: 1,
          email: this.email,
          Recurrent: 'Y',
          offert_accept: true,
          name: null,
          phone: null
        },
        isCreditEnabled: this.creditEnabled,
        variants: [],
        options: [],
        school: {},
        tinkoff_credit_enabled: false,
        price: 0,
        error: '',
        step: 1,
        avanses: [],
        paymentDates: [],
        activeTab: 'card-payment',
        isSubmit: false,
        creditType: 'school' // тип кредита
      }
    },
    watch: {
      'form.variant': 'recalcPrice',
      'form.options': function () {
        this.recalcPrice()
        this.debounceValidate()
      },
      'form.email': 'debounceValidate',
      'form.credit': 'recalcPrice',
      'avanses': 'recalcPrice',
      'form.credit_stage': 'recalcPrice',
      credit: function (newVal) {
        if (!newVal) {
          this.form.credit = false //когда включают вариант без кредита, убираем галочку
        }
      },
      email: function (newVal) {
        if (newVal) {
          this.form.email = newVal
        }
      },
      variantId: function (newVal) {
        if (newVal) {
          this.form.variant = newVal
        }
      }
    },
    computed: {
      promoCode: function () {
        switch (this.creditType) {
          case 'tinkoff_3':
            return 'installment_0_0_3_6,3';
          case 'tinkoff_6':
            return 'installment_0_0_6_10,68';
          case 'tinkoff_12':
            return 'installment_0_0_12_18,64';
        }
        return 'installment_0_0_3_6,3';
      },
      fullSum: function() {
        return  this.creditPaymentsWithOptions.reduce(function(sum, current) {
          return sum + current.price;
        }, 0);
      },
      debounceValidate: function () {
        return debounce(this.validateOrderOffer, 1500)
      },
      paymentDatesString: function () {
        if(this.creditType === 'school') {
          let dates = this.paymentDates

          dates = dates.map((item, i) => {
            if (i === 0) {
              return 'Сейчас'
            } else {
              return (new Date(item * 1000).toLocaleString('ru', {
                day: 'numeric',
                month: 'short'
              }));

            }
          })
          return dates.join(', ')
        } else {
          let date = new Date();
          let dates = []
          let end = this.creditType === 'tinkoff_12' ? 12 : (this.creditType === 'tinkoff_6' ? 6 : 3);
          for(let i=0;i<end;i++) {
            date.setMonth(date.getMonth() + 1)
            let copy = new Date(+date);
            dates.push(copy)
          }
          dates = dates.map((item) => {
              return (item.toLocaleString('ru', {
                day: 'numeric',
                month: 'short'
              }));
          })
          return '~' + dates.join(', ')
        }
      },
      availableOptions () {
        /**
         * todo допродажи
         if(this.selectedVariant.is_all_variants_available) {
        return this.offer.options
      }
         return this.offer.options.filter(option => option.available_variants.some(variant_id => variant_id === this.form.variant))
         */
        return []
      },
      availableAndSelectedOptionsIds () {
        if (this.form.options) {
          return this.form.options.filter(option_id => this.availableOptions.some(option => option.id === option_id))
        }
        return []
      },
      creditPrice () {
        // наценка на рассрочку
        if (this.credit) {
          return this.creditAdditional.toFixed(2)
        }

        return null
      },
      creditAdditional () {
        let additional = this.credit.additional
        if (String(additional).slice(0, 1) === '+') {
          additional = additional.substr(1)
        }
        if (String(additional).slice(-1) === '%') {
          additional = (this.selectedVariant.price * additional.substr(0, additional.length - 1) / 100)
        } else {
          additional = parseFloat(additional)
        }
        return additional
      },
      creditPaymentsWithOptions () {
        let optionsPrice = 0
        if (this.availableAndSelectedOptionsIds) {
          this.availableAndSelectedOptionsIds.forEach(option_id => {
            optionsPrice += this.getOptionById(option_id).price
          })
        }
        let avansesPrice = 0
        this.avanses.forEach(item => {
          avansesPrice -= item.amount
        })
        if (this.credit) {

          let orderAmountAll = this.selectedVariant.price + this.creditAdditional
            + optionsPrice + avansesPrice
          let pricePart = parseFloat((orderAmountAll / this.credit.payments_qty).toFixed(2))
          let i = 1
          let creditPaymentsWithOptions = []
          for (i; i <= this.credit.payments_qty; i++) {
            let price = (i === this.credit.payments_qty) ? parseFloat((orderAmountAll - pricePart * (this.credit.payments_qty - 1)).toFixed(2)) : pricePart
            creditPaymentsWithOptions.push({num: i, price: price})
          }
          return creditPaymentsWithOptions

        }
        return []
      },
      showCredit () {
        return !!this.credit
      },
      credit () {
        if (this.selectedVariant && this.selectedVariant.credit.is_enabled) {
          return this.selectedVariant.credit
        }
        return false
      },
      selectedVariant () {
        if (this.form.variant && this.variants) {
          return this.variants.find(
            variant => variant.id === this.form.variant
          )
        }
        return null
      },
      showCreditPayment () {
        return this.showCredit && this.form.credit === true
      },
      tinkoffCreditPartPrice () {
        let price = 0;
        if (this.form.variant) {
          price += this.selectedVariant.price
        }

        let optionsPrice = 0
        if (this.availableAndSelectedOptionsIds.length > 0) {
          this.availableAndSelectedOptionsIds.forEach(option_id => {
            optionsPrice += this.getOptionById(option_id).price
          })
          price += optionsPrice
        }

        let avansesPrice = 0
        this.avanses.forEach(item => {
          avansesPrice -= item.amount
        })
        price += avansesPrice;
        price = price / (this.creditType==='tinkoff_12'?12:(this.creditType==='tinkoff_6'?6:3));

        return parseFloat(price.toFixed(2))
      }
    },
    methods: {
      goStep(n) {
        if(n===1) {
          this.creditType = 'school'
          this.activeTab = 'card-payment'
          this.form.credit = false
        }
        this.step = n
      },
      formatPrice (price) {
        // eslint-disable-next-line
        return price.toString().replace(/^\s*(\d+)(\d{3})\s*([а-я\.0-9]+)?\s*$/, '$1 $2$3')
      },
      activateTab (tab) {
        this.activeTab = tab
        if (this.activeTab === 'rassr') {
          this.form.credit = true
        } else {
          this.creditType = 'school'
          this.form.credit = false
        }
      },
      selectTinkoffCredit () {
        this.form.credit = false
      },
      selectSchoolCredit () {
        this.form.credit = true
      },
      openOfert () {
        this.$modal.show('oferta')
      },
      ofertaAccept () {
        this.form.offert_accept = true
        this.$modal.hide('oferta')
      },
      async nextStep () {
        await this.validateOrderOffer()
        if (!this.error) {
          if (this.price === 0) {
            this.isSubmit = true
            await this.createOrder()
            this.isSubmit = false
            let url = (this.school && this.school.prefer_url) ? this.school.prefer_url : this.url;
            window.location = `${url}/register/${this.form.email}`
          } else {
            this.step = 3
          }
        }
      },
     async tinkoffCredit(createOrder, form, selectedVariant) {
       this.isSubmit = true
       let order
       try {
         order = await createOrder()
         let orderData = {
           "shopId": "maximsoldatkin",
           "showcaseId": "maximsoldatkin",
           "sum": order.amount.toFixed(2),
           "items": [
             {
               "name": selectedVariant.title,
               "quantity": 1,
               "price": order.amount.toFixed(2),
             }
           ],
           "orderNumber": order.OrderId,
           "promoCode": this.promoCode,
           "values": {
             "contact": {
               "fio": {
                 // "lastName": "Тиньков",
                 "firstName": form.name ? form.name : null,
                 // "middleName": "Юрьевич"
               },
               "mobilePhone": form.phone ? form.phone : null,
               "email": form.email
             }
           }
         }
         let response
         try {
           response = await axios.post(
               `https://forma.tinkoff.ru/api/partners/v2/orders/create`,
               orderData
           )
         } catch (e) {
           if (e.response.status === 400) {
             let errorKeys = Object.keys(e.response.data.errors)
             if (errorKeys.length > 0) {
               this.error = e.response.data.errors[errorKeys[0]][0]
             }
           } else {
             this.error = 'Неизвестная ошибка, обратитесь к администратору'
           }
           return false
         }
         window.location = response.data.link

         this.isSubmit = false
         return false

       }
       catch (e) {
         alert(e.response.data)
         this.isSubmit = true
         return false
       }
      },
      async createOrder () {
        this.error = null
        let data = {
          email: this.form.email,
          variant_id: this.form.variant,
          is_credit: this.form.credit,
          option_id: this.availableAndSelectedOptionsIds,
          label: this.form.label ? this.form.label : null,
          phone: this.form.phone ? this.form.phone : null,
          name: this.form.name ? this.form.name : null,

        }
        if (data.is_credit) {
          data.offert_accept = this.form.offert_accept
        }
        let response
        try {
          response = await axios.post(
            `${this.url}/api/payments/order-offer`,
            data
          )

        } catch (e) {
          if (e.response.status === 422) {
            let errorKeys = Object.keys(e.response.data.errors)
            if (errorKeys.length > 0) {
              this.error = e.response.data.errors[errorKeys[0]][0]
            }
          } else {
            this.error = 'Неизвестная ошибка, обратитесь к администратору'
          }
          return false
        }
        return {amount: response.data.amount, OrderId: response.data.id}
      },
      async tinkoffInit () {
        this.isSubmit = true
        let order = await this.createOrder()
        if (!order) {
          this.isSubmit = false
          return false
        }
        if (this.form.credit && this.tinkoff_credit_enabled) {
          order.Recurrent = 'Y'
        }

        let response

        try {
          response = await axios.post(
            `${this.url}/api/payments/tinkoff/init`,
            order
          )
        } catch (e) {
          this.isSubmit = false
          this.error = 'Неизвестная ошибка, обратитесь к администратору'
          return false
        }
        window.location = response.data.PaymentURL
      },
      async validateOrderOffer () {
        this.error = null
        this.avanses = []
        let data = {
          email: this.form.email,
          variant_id: this.form.variant,
          is_credit: this.form.is_credit,
          option_id: this.availableAndSelectedOptionsIds,
          label: this.form.label ? this.form.label : null
        }
        this.isSubmit = true
        try {
          let response = await axios.post(`${this.url}/api/payments/order-offer/validate`, data)
          this.avanses = response.data.avanses
          this.paymentDates = response.data.paymentDates
          this.isSubmit = false
        } catch (e) {
          this.isSubmit = false
          if (e.response.status === 422) {
            let errorKeys = Object.keys(e.response.data.errors)
            if (errorKeys.length > 0) {
              this.error = e.response.data.errors[errorKeys[0]][0]
              let validateError = errorKeys[0].split('.')

              if (validateError[0] === 'option_id' && validateError[1]) {
                let key = parseInt(validateError[1])
                this.form.options = this.form.options.filter(
                  (opt, i) => i !== key
                )
              }
            }
          } else {
            this.error = 'Неизвестная ошибка, обратитесь к администратору'
          }
          return false
        }
      },
      getOptionById (id) {
        return this.options.find(option => option.id === id)
      },
      recalcPrice () {
        this.price = 0
        if (!this.showCredit) {
          this.$emit('credit-disabled')
        }
        if (this.form.variant) {
          this.price += this.selectedVariant.price
        }

        let optionsPrice = 0
        if (this.availableAndSelectedOptionsIds.length > 0) {
          this.availableAndSelectedOptionsIds.forEach(option_id => {
            optionsPrice += this.getOptionById(option_id).price
          })
          this.price += optionsPrice
        }

        let avansesPrice = 0
        this.avanses.forEach(item => {
          avansesPrice -= item.amount
        })
        this.price += avansesPrice

        if (this.form.credit && this.credit) {
          this.price = (this.creditAdditional + this.selectedVariant.price + optionsPrice + avansesPrice) / this.credit.payments_qty
        }

        this.price = parseFloat(this.price.toFixed(2))
      },
      async fetchVariants () {
        this.isLoadingVariants = true

        let response = await axios.get(
          `${this.url}/api/payments/variants/public/${this.variantIds.join(',')}`
        )
        this.variants = this.variantIds.map(id => response.data.variants.find(item => item.id===id))
        this.school = response.data.school
        this.tinkoff_credit_enabled = this.school.tinkoff_credit_enabled

        if (!this.form.variant) {
          this.form.variant = this.variants[0].id
        }
        if(!this.isCreditEnabled) {
          if(this.school.user_id === 6) {
            this.isCreditEnabled = true
          }
        }
        this.isLoadingVariants = false
      },
      parseTariffsProp () {
        return new Promise((resolve) => {
          if(Array.isArray(this.tariffs)) {
            this.variantIds = this.tariffs
          } else {
            let ids = this.tariffs.split(',')
            ids = ids.map(id => parseInt(id))
            this.variantIds = ids
          }
          resolve()
        })
      }
    },
    async mounted () {
      await this.parseTariffsProp()
      await this.fetchVariants()
      this.recalcPrice()
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap');

  .sc {
    font-family: 'Open Sans', sans-serif;
  }

  .sc * {
    box-sizing: border-box;
  }

  .sc-card {
    max-width: 646px;
    width: 100%;
    height: auto;
    border-radius: 4px;
    border: solid 2px #efefef;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-header {
    padding: 37px 40px 0 41px;
  }

  .sc-h2 {
    font-size: 25px;
    font-weight: 600;
    line-height: 0.8;
    color: #202020;
    margin: 0;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-variants {
    padding: 32px 40px 32px 41px;
  }

  .sc-variants-item {
    border-top: solid 1px #efefef;
    display: flex;
    justify-content: space-between;
    align-content: center;
    padding: 17px 0 13px 0;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-variants-item:last-child {
    border-bottom: solid 1px #efefef;
  }

  .sc-variants-item-title {
    font-size: 13px;
    font-weight: 600;
    color: #202020;
    display: flex;
    height: auto;
  }

  .sc-variants-item-price {
    font-size: 13px;
    font-weight: normal;
    color: #757575;
    display: flex;
    height: auto;
    white-space: nowrap;
    margin-left: 20px;
  }

  .sc-radio input[type="radio"] {
    position: absolute;
    opacity: 0;
  }

  .sc-radio input[type="radio"] + .sc-radio-label {
    display: flex;
  }

  .sc-radio input[type="radio"] + .sc-radio-label:before {
    content: '';
    border-radius: 100%;
    border: solid 1px #d1d1d1;
    background-color: #f6f6f6;
    display: inline-block;
    width: 16px;
    min-width: 16px;
    height: 16px;
    position: relative;
    top: 2px;
    margin-right: 7px;
    vertical-align: top;
    cursor: pointer;
    text-align: center;
    transition: all 150ms ease;
  }

  .sc-radio input[type="radio"] + .sc-credit-label.sc-radio-label:before {
    top: 3px;
  }

  .sc-credit-types-item {
    margin-bottom: 8px;
  }

  .sc-radio input[type="radio"]:checked + .sc-radio-label:before {
    background-color: #0460e2;
    box-shadow: none;
    border: solid 1px #0460e2;
    outline: none;
  }

  .sc-radio input[type="radio"]:focus + .sc-radio-label:before {
    outline: none;
    border: solid 1px #0460e2;
    border-color: #0460e2;
  }

  .sc-radio input[type="radio"]:disabled + .sc-radio-label:before {
    box-shadow: inset 0 0 0 0 #f4f4f4;
    border-color: #b4b4b4;
    background: #b4b4b4;
  }

  .sc-radio input[type="radio"] + .sc-radio-label:empty:before {
    margin-right: 0;
  }
  .sc-radio-label.sc-credit-label {
    font-size: 13px;
    color: #202020;
    font-family: 'Open Sans', sans-serif;
  }
  .sc-buttons {
    background-color: #f4f4f4;
    padding: 0 41px 37px 41px;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-inputs {
    padding-top: 35px;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-text-input {
    height: 44px;
    width: 100%;
    max-width: 400px;
    font-size: 13px;
    color: #202020;
    outline: none;
    border-radius: 4px;
    border: solid 1px #efefef;
    background-color: #ffffff;
    padding: 0 14px;
    font-family: 'Open Sans', sans-serif;
  }

  .errors {
    color: red;
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
  }

  .mt16 {
    margin-top: 16px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .sc-button, .sc-button:focus, .sc-button:hover, .sc-button:active {
    height: 44px;
    border-radius: 4px;
    background-color: #0460e2;
    text-align: center;
    text-decoration: none;
    text-transform: none;
    font-size: 15px;
    color: #fff;
    cursor: pointer;
    outline: none;
    border: none;
    padding-left: 40px;
    padding-right: 40px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
  }

  .sc-button.loading {
    cursor: wait;
  }

  .sc-footer {
    font-size: 12px;
    color: #757575;
    padding-top: 27px;
    max-width: 646px;
    font-family: 'Open Sans', sans-serif;
  }

  .vue-dialog-buttons {
    display: flex;
    flex: 0 1 auto;
    width: 100%;
    border-top: 1px solid #eee;
  }

  .vue-dialog-button {
    font-size: 12px !important;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 40px;
    height: 40px;
    color: inherit;
    font: inherit;
    outline: none;
  }

  .oferta-content {
    padding: 14px;
  }

  .oferta-link, .v-application a.oferta-link {
    cursor: pointer;
    text-decoration: underline;
    color: #757575;
  }

  .sc-footer-images {
    display: flex;
    align-content: center;
    align-items: center;
    margin-top: 7px;
  }

  .sc-footer-images img {
    height: 100%;
  }

  .pl20 {
    padding-left: 20px;
  }

  .sc-email-label {
    padding: 16px 40px 0 41px;
    font-size: 13px;
    color: #757575;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-order-items {
    padding: 30px 40px 32px 41px;
    font-size: 13px;
    display: flex;
    flex-flow: column nowrap;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-order-item {
    border-top: solid 1px #efefef;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 14px 0 15px 0;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-order-item:last-child {
    border-bottom: solid 1px #efefef;
  }

  .sc-order-item-price {
    color: #757575;
    font-family: 'Open Sans', sans-serif;
    white-space: nowrap;
    margin-left: 20px;
  }

  .sc-order-item-price.sc-avanse {
    color: #0bab55;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-tabs {
    display: flex;
    border-bottom: solid 1px #efefef;
    padding: 18px 0 0 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    margin-block-start: 0;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-tabs-item {
    padding: 7px 22px;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    color: #757575;
    list-style-type: none;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-tabs-item-active {
    color: #202020;
    border-bottom: solid 3px #0460e2;
  }

  .sc-order-sum {
  }

  .mt25 {
    margin-top: 25px;
  }

  .sc-order-sum-label {
    font-size: 13px;
    color: #757575;
  }

  .sc-order-sum-value {
    font-size: 25px;
    font-weight: 600;
    line-height: 0.8;
    color: #202020;
    padding-top: 5px;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-order-sum-value span {
    font-weight: normal;
  }

  .sc-order {
    display: flex;
    padding-top: 20px;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-credit-details {
    font-size: 13px;
    display: flex;
    padding-left: 0;
    padding-top: 0;
    flex-flow: row wrap;
    justify-content: space-between;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-grey-text {
    color: #757575;
  }

  .sc-payment-dates {
    padding-top: 10px;
    font-family: 'Open Sans', sans-serif;
  }

  .sc-credit-types {
    padding-bottom: 20px;
  }

  .sc-credit-graph {
    flex-grow: 1;
  }

  .sc-credit-sum {
  }

  .sc-credit-hint {
    width: 100%;
    padding-top: 20px;
  }
  i {
    display: inline-block;
    font-style: normal;
    position: relative;
  }
  .sc-back {
    font-size: 13px;
    color: #757575;
    padding-bottom: 15px;
    cursor: pointer;
    font-family: 'Open Sans', sans-serif;
  }
  /* Additional formatting for arrow icon */
  i.sc-arrow {
    /* top: 2pt; Uncomment this to lower the icons as requested in comments*/
    width: 8px;
    height: 8px;
    border-left: 2px solid #949494;
    border-top: 2px solid #949494;
    transform: rotate(-45deg);
  }

  .sc-flex {
    display: flex;
  }

  .mt0 {
    margin-top: 0;
  }

  @media screen and (max-width: 600px) {
    .sc-h2 {
      font-size: 22px;
    }
    .sc-header {
      padding: 32px 20px 0 20px;
    }
    .sc-variants {
      padding: 32px 20px 32px 20px;
    }
    .sc-buttons {
      padding: 0 20px 32px 20px;
    }
    .sc-email-label {
      padding: 16px 20px 0 20px;
    }
    .sc-order-items {
      padding: 30px 20px 32px 20px;
    }
    .sc-tabs-item {
      padding: 7px 17px;
    }
    .sc-credit-details {
      margin-left: 10px;
      text-align: right;
    }
    .sc-flex .sc-button {
      padding: 0 30px;
    }
  }

</style>
